import React, { useState, useEffect } from "react";
import MenuBar from "./menu/MenuBar";
import {
  Form,
  Card,
  Divider,
  Input,
  Radio,
  Select,
  DatePicker,
  Button,
  Modal,
  notification,
} from "antd";
import { format } from "../App";

import { useSelector } from "react-redux";

import moment from "moment";
import { changLgValue, getDataPost_2, getPDF_2, getTextDate } from "../data/allfunction_2";
import { Spinshow } from "./SellPac";
import { pad } from "../data/allfunction";
import { fromTypeCar } from "./SellThirt_2";
const ip = process.env.REACT_APP_IP;

const SellShot_2 = () => {
  const { token, retoken, user_id } = useSelector((state) => {
    return state.user;
  });
  const { value } = useSelector((state) => state.lg);
  const { Option } = Select;
  const [form] = Form.useForm();
  const [register, setregister] = useState(0);
  const [vat, setvat] = useState(0);
  const [total_premuim, settotal_premuim] = useState(0);
  const [modalsave, setmodalsave] = useState(false);

  const [o_name, seto_name] = useState("");
  const [o_tel, seto_tel] = useState("");
  const [o_type, seto_type] = useState("");
  const [o_make, seto_make] = useState("");
  const [o_plate, seto_plate] = useState("");

  const [o_engine, seto_engine] = useState("");
  const [o_chassis, seto_chassis] = useState("");
  const [a_type_power, set_a_type_power] = useState(0);

  const [dayCover, setDayCover] = useState({});

  const [listData, setlistData] = useState([]);
  const [emp_paid, setemp_paid] = useState(0);
  const [premuim, setpremuim] = useState(0);
  const [provice, setprovice] = useState([]);
  const [dist, setdist] = useState([]);
  const [proviceid, setproviceid] = useState(null);

  const [proviceSelect, setproviceSelect] = useState("");
  const [distSelect, setdistSelect] = useState("");
  const [villageSelect, setvillageSelect] = useState("");

  // const [startCover, setstartCover] = useState();

  const [sent_startCover, setsent_startCover] = useState("");
  const [sent_endCover, setsent_endCover] = useState("");

  const [cover, setcover] = useState("");
  const [option, setOption] = useState(0);

  // const [thirdcover_option, setthirdcover_option] = useState([]);

  const dateFormat = "DD-MM-YYYY";
  // const dateFormat2 = "DD-MM-YYYY HH:mm:ss";
  const [car_options, setcar_options] = useState([]);
  const [day_sell_shot, setday_sell_shot] = useState([]);
  const [carType, setCarType] = useState({});
  const [thirdPatryPremuim, setThirdPatryPremuim] = useState([]);

  const [driveType, setdriveType] = useState([]);
  const [opDriveType, setOpDriveType] = useState([]);
  const [driveTypeOne, setdriveTypeOne] = useState({});
  const [opDriveTypeOne, setOpDriveTypeOne] = useState({});
  const [driver_op_code, set_driver_op_code] = useState("");
  const [getTax, set_getTax] = useState([]);
  const [driverPremuim, setDriverPremuim] = useState([]);
  const [loadingPDF, setloadingPDF] = useState(false);

  const [stateButtonSave, setstateButtonSave] = useState(true);

  function onChange_timestart(value, dateString) {
    // setstartCover(moment(value).format(dateFormat));
    setsent_startCover(value);
  }

  const onChange_dist = (e) => {
    let dist = JSON.parse(e);
    // console.log(dist.dist_name)
    setdistSelect(dist.dist_name);
  };
  function onChange_pro(p) {
    let pro = JSON.parse(p);
    setproviceid(pro.provice_id);
    setproviceSelect(pro.provice_name);
  }
  const submitForm = (e) => {
    setmodalsave(true);
  };
  //ດິງຂໍ້ມູນປະເພດ ອ້ອບຊັ່ນບຸກຄຸນທີສາມ

  async function createPolicy() {
    setstateButtonSave(false);
    setloadingPDF(true);
    // let link = `${ip}sell_online/short`;
    const dataSetForGet = {
      o_name: o_name,
      // o_address: o_address,
      o_address: `${villageSelect} ເມືອງ ${distSelect} ແຂວງ ${proviceSelect}`,
      o_tel: o_tel,
      o_type: o_type,
      o_make: o_make,
      o_plate: o_plate,
      o_engine: o_engine,
      o_chassis: o_chassis,
      premuim: premuim,
      vat: vat,
      register: register,
      total_premuim: total_premuim,
      start: moment(sent_startCover).format("YYYY-MM-DD"),
      end: moment(sent_endCover).format("YYYY-MM-DD"),
      cover: cover,
      user_add: user_id,
      dateadd: Date.now(),
      emp_paid: emp_paid,
      a_type_power,
    };

    let dataSetForGet1 = {
      thirdData: {
        car_option_detail_ms_id: thirdPatryPremuim[0].car_option_detail_ms_id,
      },
      typedriverdata: {
        driver_option_detail_id: driverPremuim[0].driver_option_detail_id,
      },
      emp_add: null,
      thediductible: null,
    };

    // console.log({ ...dataSetForGet, ...dataSetForGet1 });
    let rows = { ...dataSetForGet, ...dataSetForGet1 };
    let l = ip + "sell_2_online/insert_short";
    let addpolicy = await getDataPost_2(l, rows, token, retoken);

    if (addpolicy.affectedRows === 1) {
      notification["success"]({
        message: "ແຈ້ງເຕືອນ",
        description:
          "ສ້າງສັນຍາປະກັນໄພອອນລາຍ ເລກທີ: " +
          pad(addpolicy.insertId) +
          " ສຳເຫຼັ້ດ ກະລຸນາກວດສອບໂຟເດີ້ ດາວໂລດ",
      });
      setmodalsave(false);
      get_pdf_policy(addpolicy.insertId);
      setTimeout(() => {
        window.location.reload();
        setloadingPDF(false);
        notification.destroy();
      }, 6000);
    } else {
      setloadingPDF(false);
      setmodalsave(false);
    }
    setTimeout(() => {
      setstateButtonSave(true);
    }, 3000);
  }

  async function get_pdf_policy(no) {
    let l = ip + "sell_2_online/pdf_short";
    let dataSetForGet = { no };
    let pro = await getPDF_2(l, dataSetForGet, token, retoken);

    // Create a temporary URL representing the Blob
    const url = window.URL.createObjectURL(pro);

    // Create a link element
    const a = document.createElement("a");
    a.href = url;
    a.download = `MS-${pad(no)}`;

    // Append the link to the body
    document.body.appendChild(a);

    // Trigger a click event on the link to initiate download
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  function onChange_v(v) {
    setvillageSelect(v.target.value);
  }

  function onChange_Car(value) {
    let v = JSON.parse(value);
    // console.log(v);
    setCarType(v);
    seto_type(v.car_type_name_la);
  }

  useEffect(() => {
    if (sent_startCover !== "") {
      if (dayCover.day_id === 1) {
        setsent_endCover(moment(sent_startCover).add(7, "d").subtract(1, "d"));
      } else if (dayCover.day_id === 2) {
        setsent_endCover(moment(sent_startCover).add(15, "d").subtract(1, "d"));
      } else if (dayCover.day_id === 3) {
        setsent_endCover(moment(sent_startCover).add(21, "d").subtract(1, "d"));
      } else if (dayCover.day_id === 4) {
        setsent_endCover(
          moment(sent_startCover).add(1, "months").subtract(1, "d")
        );
      } else if (dayCover.day_id === 5) {
        setsent_endCover(
          moment(sent_startCover).add(3, "months").subtract(1, "d")
        );
      } else if (dayCover.day_id === 6) {
        setsent_endCover(
          moment(sent_startCover).add(6, "months").subtract(1, "d")
        );
      } else if (dayCover.day_id === 7) {
        setsent_endCover(
          moment(sent_startCover).add(9, "months").subtract(1, "d")
        );
      }
    }
  }, [dayCover, sent_startCover]);

  useEffect(() => {
    let re = 20000;
    let A, B, C, D;
    A = total_premuim;
    B = re;
    C = (A - B) / (1 + getTax);
    D = C * getTax;

    setpremuim(C);
    setvat(D);

    // ຄິດໄລ່ຄ່າຂື້ນທະບຽນ-----------
    //   let r
    //   if (C <= 10000000) {
    //       r = 20000
    //   } else if (C <= 50000000) {
    //       r = 30000
    //   } else if (C <= 100000000) {
    //       r = 40000
    //   } else {
    //       r = 100000
    //   }
    //   setregister(r)

    setregister(B);
  }, [total_premuim, getTax]);

  useEffect(() => {
    setcover(option.car_op_name + `-H-` + driver_op_code);
  }, [option, driver_op_code]);

  //------------

  //ດຶງປະເພດລົດທັງໝົ້ດ ແລະ ທາງເລືອກ ແລະ ຈຳນວນວັນ
  useEffect(() => {
    getData();
    async function getData() {
      let l = ip + "sell_2_online/car_type_ms";
      let dataSetForGet = {};
      let pro = await getDataPost_2(l, dataSetForGet, token, retoken);
      //  console.log(pro);
      if (pro?.length > 0) {
        setlistData(pro);
      } else {
        setlistData([]);
      }

      let lcar_options = ip + "sell_2_online/car_options";
      let dataSetForGetcar_options = {};
      let procar_options = await getDataPost_2(
        lcar_options,
        dataSetForGetcar_options,
        token,
        retoken
      );
      //  console.log(procar_options);
      if (procar_options?.length > 0) {
        setcar_options(procar_options);
      } else {
        setcar_options([]);
      }

      let lday = ip + "sell_2_online/day_sell_shot";
      let dataSetForGetday = {};
      let proday = await getDataPost_2(lday, dataSetForGetday, token, retoken);
      if (proday?.length > 0) {
        try {
          const result = proday.filter((item) => item.day_status_e === 1);
          setday_sell_shot(result);
        } catch (error) {
          setday_sell_shot([]);
        }
      } else {
        setday_sell_shot([]);
      }
    }
  }, [token, retoken]);

  //ດຶງແຂວງທັງໝົ້ດ
  useEffect(() => {
    getData();
    async function getData() {
      let l = ip + "sell_2_online/provice";
      let dataSetForGet = {};
      let pro = await getDataPost_2(l, dataSetForGet, token, retoken);
      // console.log(pro);
      if (pro?.length > 0) {
        setprovice(pro);
      } else {
        setprovice([]);
      }
    }
  }, [token, retoken]);
  //ລາຍຊື່ເມືອງຕາມແຂວງ
  useEffect(() => {
    setdist([]);
    getData();
    async function getData() {
      if (proviceid != null) {
        let l = ip + "sell_2_online/distic";
        let dataSetForGet = { dist_provice: proviceid };
        let dis = await getDataPost_2(l, dataSetForGet, token, retoken);
        //   console.log(dis);
        if (dis?.length > 0) {
          setdist(dis);
        } else {
          setdist([]);
        }
      }
    }
  }, [proviceid, token, retoken]);

  useEffect(() => {
    let car_type_id = carType?.car_type_id;
    let day_id = dayCover?.day_id;
    let car_op_id = option?.car_op_id;

    if (
      car_type_id === undefined ||
      day_id === undefined ||
      car_op_id === undefined
    ) {
      //   console.log("ບໍ່ດຶງຂໍ້ມູນ");
    } else {
      get(car_type_id, day_id, car_op_id);
    }

    async function get(car_type_id, day_id, car_op_id) {
      try {
        let l = ip + "sell_2_online/car_option_detail_ms";
        let dataSetForGet = { car_type_id, day_id, car_op_id };
        let detail_ms = await getDataPost_2(l, dataSetForGet, token, retoken);
        //   console.log(detail_ms);
        settotal_premuim(detail_ms[0].car_option_detail_ms_premuim);
        if (detail_ms?.length > 0) {
          setThirdPatryPremuim(detail_ms);
        } else {
          throw new Error();
        }
      } catch (error) {
        alert("ປະເພດລົດດັ່ງກ່າວ ບໍ່ສາມາດຂາຍທາງເລືອກນີ້ໃດ້ ກະລຸນາກວດສອບຄືນໃໝ່");
        settotal_premuim(0);
        setThirdPatryPremuim([]);
        setcover("");
      }
    }
  }, [carType, option, dayCover, token, retoken]);

  //ດຶງປະເພດຜູ້ຂັບຂີ່ ແລະ ທາງເລືອກຜູ້ຂັບຂີ່ ທັງໝົດ
  useEffect(() => {
    getData();
    async function getData() {
      let l = ip + "sell_2_online/drivers";
      let dataSetForGet = {};
      let driver = await getDataPost_2(l, dataSetForGet, token, retoken);
      // console.log(driver);
      if (driver?.length > 0) {
        setdriveType(driver);
      } else {
        setdriveType([]);
      }

      let l2 = ip + "sell_2_online/driver_options";
      let dataSetForGet2 = {};
      let op_driver = await getDataPost_2(l2, dataSetForGet2, token, retoken);
      //  console.log(op_driver);
      if (op_driver?.length > 0) {
        setOpDriveType(op_driver);
      } else {
        setOpDriveType([]);
      }
    }
  }, [token, retoken]);
  //ດຶງຂໍ້ມູນອາກອນມູນຄ່າເພີ່ມ
  useEffect(() => {
    getData();
    async function getData() {
      let l = ip + "sell_2_online/tax";
      let dataSetForGet = {};
      let _tax = await getDataPost_2(l, dataSetForGet, token, retoken);
      //  console.log(_tax);
      if (_tax?.length > 0) {
        const vat = getTextDate(_tax[0].tax_value);
        // set_getTax(_tax[0].tax_value);
        set_getTax(vat);
      } else {
        set_getTax(0);
      }
    }
    //
  }, [token, retoken]);

  //ເມື່ອປະເພດຜູ້ຂັບຂີ່ ແລະ ປະເພດອອບຊັ່ນມີການປ່ຽນແປງ ແລ້ວດຶງເອົາຄ່າທຳນຽມຜູ້ຂັບຂີ່
  useEffect(() => {
    getData();
    async function getData() {
      try {
        if (
          opDriveTypeOne?.driver_op_id != undefined &&
          driveTypeOne?.driver_id != undefined
        ) {
          // console.log("opDriveTypeOne", opDriveTypeOne);
          // console.log("driveTypeOne", driveTypeOne);

          let l = ip + "sell_2_online/driver_options_detail";
          let dataSetForGet = {
            driver_id: driveTypeOne?.driver_id,
            driver_op_id: opDriveTypeOne?.driver_op_id,
          };
          let driver = await getDataPost_2(l, dataSetForGet, token, retoken);
          //     console.log(driver);
          if (driver?.length > 0) {
            setDriverPremuim(driver);
          } else {
            alert(
              "ປະເພດຜູ້ຂັບຂີ່ດັ່ງກ່າວ ບໍ່ສາມາດຂາຍທາງເລືອກນີ້ໃດ້ ກະລຸນາກວດສອບຄືນໃໝ່"
            );
            setDriverPremuim([]);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  }, [driveTypeOne, opDriveTypeOne, token, retoken]);
  return (
    <div>
      <MenuBar />
      {loadingPDF ? <Spinshow /> : Datashow()}

      <Modal
        // title="ກວດຂໍ້ມູນໃຫ້ລະອຽດກ່ອນການບັນທືກ"
        title={changLgValue(value, 61)}
        visible={modalsave}
        onOk={() => {
          if (stateButtonSave) {
            createPolicy();
          } else {
            alert("ກະລຸນາລໍຖ້າທ່ານໃດ້ ກົດບັນທຶກຂໍ້ມູນແລ້ວ");
          }
        }}
        onCancel={() => setmodalsave(false)}
        okText="ຕົກລົງ"
        cancelText="ຍົກເລີກ"
      >
        <div className="B">
          <div className="B1">
            {/* ຜູ້ໃດ້ຮັບການປະກັນໄພ  */}
            {changLgValue(value, 7)}
          </div>
          <div className="B2">{o_name}</div>
        </div>
        <div className="B">
          <div className="B1">
            {/* ເລກທະບຽນ */}
            {changLgValue(value, 13)}
          </div>
          <div className="B2">{o_plate}</div>
        </div>
        <div className="B">
          <div className="B1">
            {/* ເລກຈັກ  */}
            {changLgValue(value, 16)}</div>
          <div className="B2">{o_engine}</div>
        </div>
        <div className="B">
          <div className="B1">
            {changLgValue(value, 17)}
            {/* ເລກຖັງ  */}
          </div>
          <div className="B2">{o_chassis}</div>
        </div>
        <div className="B">
          <div className="B1">
            {/* ການຄຸ້ມກັນ  */}
            {changLgValue(value, 86)}
          </div>
          <div className="B2">{cover}</div>
        </div>
        <div className="B">
          <div className="B1">  {/* ວັນທີເລີ່ມຄຸ້ມກັນ  */}
            {changLgValue(value, 76)} </div>
          <div className="B2">{moment(sent_startCover).format(dateFormat)}</div>
        </div>
        <div className="B">
          <div className="B1">  {/* ວັນທີສຶ້ນສຸດຄຸ້ມກັນ  */}
            {changLgValue(value, 77)} </div>
          <div className="B2">{moment(sent_endCover).format(dateFormat)}</div>
        </div>
        <div className="B">
          <div className="B1">
            {/* ລວມມູນຄ່າຕ້ອງຈ່າຍ  */}
            {changLgValue(value, 85)}
          </div>
          <div className="B2">{format(total_premuim)}</div>
        </div>
        <div className="B">
          <div className="B1"> {/* ສະຖານະການຊຳລະ */}
            {changLgValue(value, 57)} </div>
          <div className="B2">
            {" "}
            {emp_paid === 1 ?

              //  "ຊຳລະສົມບູນ"
              changLgValue(value, 57)
              :
              // "ລໍຖ້າການຊຳລະ"
              changLgValue(value, 56)

            }
          </div>
        </div>
      </Modal>
    </div>
  );

  function Datashow() {
    return (
      <Form
        form={form}
        name="sellshot"
        // labelCol={{ span: 8 }}
        // wrapperCol={{ span: 16 }}
        initialValues={{ remember: true }}
        onFinish={submitForm}
        autoComplete="off"
      >
        <div className="container">
          <Card className="C">
            <Divider orientation="left" plain>
              {/* ຂໍ້ມູນຂອງຜູ້ໄດ້ຮັບການປະກັນໄພ _2 */}
              {changLgValue(value, 6)} v2

            </Divider>
            <div style={{ display: "flex" }}>
              <div style={{ flex: 2, paddingRight: 10 }}>
                <Form.Item
                  name="o_name"
                  className="mb-0"
                  rules={[{ required: false }]}
                >
                  <Input
                    className="TI"
                    // placeholder="ຊື່ ແລະ ນາມສະກຸນ"
                    placeholder={changLgValue(value, 7)}
                    onChange={(e) => {
                      seto_name(e.target.value);
                    }}
                  />
                </Form.Item>

                <div className="row row-cols-1 row-cols-md-3">
                  <div className="col">
                    <Select
                      // placeholder="ເລືອກແຂວງ"
                      placeholder={changLgValue(value, 8)}
                      optionFilterProp="children"
                      onChange={onChange_pro}
                      className="TI"
                      style={{ width: "100%" }}
                    >
                      {provice.map((v) => {
                        return (
                          <Option key={v.provice_id} value={JSON.stringify(v)}>
                            {v.provice_name}
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                  <div className="col">
                    <Select
                      // placeholder="ເລືອກເມືອງ"
                      placeholder={changLgValue(value, 9)}
                      optionFilterProp="children"
                      onChange={onChange_dist}
                      className="TI"
                      style={{ width: "100%" }}
                    >
                      {dist.map((v) => {
                        return (
                          <Option key={v.dist_id} value={JSON.stringify(v)}>
                            {v.dist_name}
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                  <div className="col">
                    <Input
                      className="TI"
                      // placeholder="ພິມຊື່ບ້ານ"
                      placeholder={changLgValue(value, 10)}
                      onChange={onChange_v}
                    />
                  </div>
                </div>
                <Input
                  className="TI"
                  // placeholder="ໂທລະສັບ"
                  placeholder={changLgValue(value, 11)}
                  onChange={(e) => {
                    seto_tel(e.target.value);
                  }}
                />

                <Input
                  className="TI"
                  // placeholder="ຫຍີ່ຫໍ້"
                  placeholder={changLgValue(value, 12)}
                  onChange={(e) => {
                    seto_make(e.target.value);
                  }}
                />
                <Input
                  className="TI"
                  // placeholder="ເລກທະບຽນ"
                  placeholder={changLgValue(value, 13)}
                  onChange={(e) => {
                    seto_plate(e.target.value);
                  }}
                />

                <Input
                  className="TI"
                  // placeholder="ເລກຈັກ"
                  placeholder={changLgValue(value, 16)}
                  onChange={(e) => {
                    seto_engine(e.target.value.toUpperCase());
                    // console.log(e.target.value.toUpperCase())
                  }}
                  value={o_engine}
                />
                <Input
                  className="TI"
                  // placeholder="ເລກຖັງ"
                  placeholder={changLgValue(value, 17)}
                  onChange={(e) => {
                    seto_chassis(e.target.value.toUpperCase());
                  }}
                  value={o_chassis}
                />
                {/* ບ່ອນໃສ່ຄ່າທຳນຽມດ້ວນຕົນເອງ */}
                {/* <Form.Item
                // label=" ເລືອກປະເພດລົດ::"
                name="total_premuim"
                rules={[
                  {
                    required: true,
                    message: "ກະລຸນາເພີ່ມ ຄ່າທຳນຽມປະກັນໄພສຸດທ້າຍ ເສຍກ່ອນ",
                  },
                ]}
                className="mb-0"
              >
                <Input
                  type="number"
                  className="TI"
                  placeholder="ຄ່າທຳນຽມປະກັນໄພສຸດທ້າຍ"
                  onChange={(e) => {
                    settotal_premuim(e.target.value);
                  }}
                />
              
              </Form.Item> */}
                {fromTypeCar(a_type_power, set_a_type_power, value)}
              </div>
            </div>
          </Card>
          <Card className="C">
            <Divider orientation="left" plain>
              {/* ຜູ້ຂັບຂີ່ */}
              {changLgValue(value, 87)}
            </Divider>
            <div className="BDP">
              <div className="B1DP">
                {/* ປະເພດຜູ້ຂັບຂີ່ */}
                {changLgValue(value, 41)}
                <hr />
                <Form.Item
                  name="driver"
                  className="mb-0"
                  rules={[
                    {
                      required: true,
                      message: "ກະລຸນາເລືອກ  ເລືອກປະເພດຜູ້ຂັບຂີ່",
                    },
                  ]}
                >
                  <Radio.Group
                    onChange={(v) => {
                      // console.log("ປະເພດຜູ້ຂັບຂີ່");
                      setdriveTypeOne(v.target.value);
                    }}
                    className="R"
                  >
                    {driveType.map((e, k) => {
                      return e.driver_id === 4 ? null : (
                        <Radio key={k} value={e}>
                          {e.driver_name}
                        </Radio>
                      );
                    })}
                  </Radio.Group>
                </Form.Item>
              </div>
              <div className="B2DP">
                {/* ທາງເລືອກຜູ້ຂັບຂີ່  */}
                {changLgValue(value, 46)}
                <hr />
                <Form.Item
                  // label=" ເລືອກປະເພດລົດ::"
                  name="driOp"
                  rules={[
                    {
                      required: true,
                      message: "ກະລຸນາເລືອກ  ທາງເລືອກຜູ້ຂັບຂີ່",
                    },
                  ]}
                  className="mb-0"
                >
                  <Select
                    // placeholder="ທາງເລືອກຜູ້ຂັບຂີ່"
                    placeholder={changLgValue(value, 47)}
                    onChange={(v) => {
                      let showI = JSON.parse(v).driver_op_code;
                      if (showI === "null") {
                        set_driver_op_code("");
                      } else {
                        set_driver_op_code(showI);
                      }

                      setOpDriveTypeOne(JSON.parse(v));
                    }}
                    className="TI"
                    style={{ width: "100%" }}
                  >
                    {opDriveType.map((v) => {
                      if (v.driver_op_id == 3) {
                        return (
                          <Option
                            key={v.driver_op_id}
                            value={JSON.stringify(v)}
                          >
                            {v.driver_op_code}
                          </Option>
                        );
                      }
                    })}
                  </Select>
                </Form.Item>
              </div>
            </div>
          </Card>

          <Card className="C">
            <Divider orientation="left" plain>
              {/* ທາງເລືອກການຄຸ້ມກັນ */}
              {changLgValue(value, 86)}
            </Divider>

            {/* <div className="BDP">
              <div className="B1DP">
                ເລືອກປະເພດລົດ
                <hr />
                <Form.Item
                  // label=" ເລືອກປະເພດລົດ::"
                  name="o_type"
                  rules={[
                    {
                      required: true,
                      message: "ກະລຸນາເລືອກ  ເລືອກປະເພດລົດ ເສຍກ່ອນ",
                    },
                  ]}
                  className="mb-0"
                >
                  <Select
                    placeholder="ປະເພດລົດ"
                    optionFilterProp="children"
                    onChange={onChange_Car}
                    className="TI"
                    style={{ width: "100%" }}
                  >
                    {listData.map((v, i) => {
                      return v.car_type_ms === 1 ? (
                        <Option key={i} value={JSON.stringify(v)}>
                          {v.car_type_name_la}
                        </Option>
                      ) : null;
                    })}
                  </Select>
                </Form.Item>
              </div>
              <div className="B2DP" style={{ paddingLeft: 15 }}>
                ເລືອກທາງເລືອກ
                <hr />
                <Form.Item
                  name="o_thirOp"
                  rules={[
                    {
                      required: true,
                      message: "ກະລຸນາເລືອກ ທາງເລືອກບຸກຄົນທີສາມ",
                    },
                  ]}
                  className="mb-0"
                >
                  <Radio.Group
                    onChange={(e) => {
                      setOption(e.target.value);
                    }}
                    value={option}
                  >
                    {car_options.map((e, i) => {
                      return (
                        <Radio key={i} value={e}>
                          {e.car_op_name}
                        </Radio>
                      );
                    })}
                  </Radio.Group>
                </Form.Item>
              </div>
            </div> */}
            <br />


            <div className="row row-cols-1 row-cols-md-2" style={{ padding: 5, backgroundColor: '' }}>
              <div className="col" style={{ backgroundColor: '' }}>
                {/* ເລືອກປະເພດລົດ */}
                {changLgValue(value, 89)}
                <hr />
                <Form.Item
                  // label=" ເລືອກປະເພດລົດ::"
                  name="o_type"
                  rules={[
                    {
                      required: true,
                      message: "ກະລຸນາເລືອກ  ເລືອກປະເພດລົດ ເສຍກ່ອນ",
                    },
                  ]}
                  className="mb-0"
                >
                  <Select
                    // placeholder="ປະເພດລົດ"
                    placeholder={changLgValue(value, 36)}
                    optionFilterProp="children"
                    onChange={onChange_Car}
                    className="TI"
                    style={{ width: "100%" }}
                  >
                    {listData.map((v, i) => {
                      return v.car_type_ms === 1 ? (
                        <Option key={i} value={JSON.stringify(v)}>
                          {/* {v.car_type_name_la} */}
                          {value == 1 ? v.car_type_name_la : v.car_type_name_ch}
                        </Option>
                      ) : null;
                    })}
                  </Select>
                </Form.Item>
              </div>
              <div className="col" style={{ backgroundColor: '' }}>
                {/* ເລືອກທາງເລືອກ */}
                {changLgValue(value, 90)}
                <hr />
                <Form.Item
                  name="o_thirOp"
                  rules={[
                    {
                      required: true,
                      message: "ກະລຸນາເລືອກ ທາງເລືອກບຸກຄົນທີສາມ",
                    },
                  ]}
                  className="mb-0"
                >
                  <Radio.Group
                    onChange={(e) => {
                      setOption(e.target.value);
                    }}
                    value={option}
                  >
                    {car_options.map((e, i) => {
                      return (
                        <Radio key={i} value={e}>
                          {e.car_op_name}
                        </Radio>
                      );
                    })}
                  </Radio.Group>
                </Form.Item>
              </div>
            </div>
          </Card>



          <Card className="C">
            <Divider orientation="left" plain>
              {/* ຊ່ວງເວລາຄຸ້ມກັນ */}
              {changLgValue(value, 91)}
            </Divider>

            {/* <div className="BDP">
              <div className="B1DP">
                <div className="row">
                  <Form.Item
                    label="ວັນທີເລີ່ມຄຸ້ມກັນ::"
                    name="start"
                    rules={[
                      {
                        required: true,
                        message: "ກະລຸນາເລືອກ ວັນທີເລີ່ມຄຸ້ມກັນ ເສຍກ່ອນ",
                      },
                    ]}
                  >
                    <DatePicker
                      placeholder="ວັນທີເລີ່ມຄຸ້ມກັນ"
                      className="DP"
                      //  showTime
                      onChange={onChange_timestart}
                      format={dateFormat}
                      disabledDate={(current) =>
                        current.isBefore(moment().subtract(1, "day"))
                      }
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="B2DP">
                ຈຳນວນວັນຄຸ້ມກັນ
                <div className="row">
                  <Form.Item
                    name="o_day"
                    rules={[
                      {
                        required: true,
                        message: "ກະລຸນາເລືອກ ຈຳນວນວັນຄຸ້ມກັນ",
                      },
                    ]}
                    className="mb-0"
                  >
                    <Radio.Group
                      onChange={(e) => {
                        //   console.log(e.target.value);
                        setDayCover(e.target.value);
                      }}
                    //  value={dayCover}
                    >
                      {day_sell_shot.map((e, i) => {
                        return (
                          <Radio key={i} value={e}>
                            {e.day_name}
                          </Radio>
                        );
                      })}
                    </Radio.Group>
                  </Form.Item>
                </div>
                <br />
                <div className="row">
                  <div className="col-md-6">
                    {sent_startCover != "" && (
                      <>
                        ວັນທີເລີ່ມຄຸ້ມກັນ{" "}
                        {moment(sent_startCover).format(dateFormat)}
                      </>
                    )}
                  </div>
                  <div className="col-md-6">
                    {sent_endCover != "" && (
                      <>
                        ວັນທີສຶ້ນສຸດຄຸ້ມກັນ{" "}
                        {moment(sent_endCover).format(dateFormat)}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div> */}



            <div className="row row-cols-1 row-cols-md-2" style={{ padding: 5, backgroundColor: '' }}>
              <div className="col" style={{ backgroundColor: '' }}>
                <Form.Item
                  // label="ວັນທີເລີ່ມຄຸ້ມກັນ::"
                  label={changLgValue(value, 58)}
                  name="start"
                  rules={[
                    {
                      required: true,
                      message: "ກະລຸນາເລືອກ ວັນທີເລີ່ມຄຸ້ມກັນ ເສຍກ່ອນ",
                    },
                  ]}
                >
                  <DatePicker
                    // placeholder="ວັນທີເລີ່ມຄຸ້ມກັນ"
                    placeholder={changLgValue(value, 59)}
                    className="DP"
                    //  showTime
                    onChange={onChange_timestart}
                    format={dateFormat}
                    disabledDate={(current) =>
                      current.isBefore(moment().subtract(1, "day"))
                    }
                  />
                </Form.Item>
              </div>
              <div className="col" style={{ backgroundColor: '' }}>
                {/* ເລືອກຈຳນວນວັນຄຸ້ມກັນ */}
                {changLgValue(value, 64)}
                <div className="row">
                  <Form.Item
                    name="o_day"
                    rules={[
                      {
                        required: true,
                        message: "ກະລຸນາເລືອກ ຈຳນວນວັນຄຸ້ມກັນ",
                      },
                    ]}
                    className="mb-0"
                  >
                    <Radio.Group
                      onChange={(e) => {
                        //   console.log(e.target.value);
                        setDayCover(e.target.value);
                      }}
                    //  value={dayCover}
                    >
                      {day_sell_shot.map((e, i) => {
                        return (
                          <Radio key={i} value={e}>
                            {e.day_name}
                          </Radio>
                        );
                      })}
                    </Radio.Group>
                  </Form.Item>
                </div>
              </div>
            </div>
          </Card>









          <Card className="C">
            <Divider orientation="left" plain>
              {/* ຄິດໄລຄ່າທຳນຽມ */}
              {changLgValue(value, 49)}
            </Divider>
            <div className="B">
              <div className="B1">
                {/* ຄ່າທຳນຽມຕົວຈິງບໍ່ທັນລວມອາກອນ  */}
                {changLgValue(value, 50)}
              </div>
              <div className="B2">{premuim > 0 ? format(premuim) : 0}</div>
            </div>
            <div className="B">
              <div className="B1">
                {" "}
                {/* ອາກອນມູນຄ່າເພີ່ມ  */}
                {changLgValue(value, 51)}
                {format(getTax * 100)} %{" "}
              </div>
              <div className="B2">{vat > 0 ? format(vat) : 0}</div>
            </div>
            <div className="B">
              <div className="B1">
                {/* ຄ່າຂື້ນທະບຽນ  */}
                {changLgValue(value, 52)}
              </div>
              <div className="B2">
                {total_premuim > 0 ? format(register) : 0}
              </div>
            </div>
            <div className="B">
              <div className="B1">
                {/* ລວມມູນຄ່າຕ້ອງຈ່າຍ  */}
                {changLgValue(value, 53)}
              </div>
              <div className="B2">
                {total_premuim > 0 ? format(total_premuim) : 0}
              </div>
            </div>
          </Card>
          <Card className="C">
            <Divider orientation="left" plain>
              {/* ການຊຳລະເງິນ */}
              {changLgValue(value, 54)}
            </Divider>
            <div className="BDP">
              <div className="B1DP">
                {/* ສະຖານະການຊຳລະ */}
                {changLgValue(value, 55)}
              </div>
              <div className="B2DP">
                <Radio.Group
                  onChange={(e) => {
                    setemp_paid(e.target.value);
                  }}
                  value={emp_paid}
                >
                  <Radio value={0}>
                    {/* ລໍຖ້າການຊຳລະ */}
                    {changLgValue(value, 56)}
                  </Radio>
                  <Radio value={1}>
                    {/* ຊຳລະສົມບູນ */}
                    {changLgValue(value, 57)}
                  </Radio>
                </Radio.Group>
              </div>
            </div>
          </Card>

          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
              {/* ບັນທຶກຂໍ້ມູນ */}
              {changLgValue(value, 60)}
            </Button>
          </Form.Item>
        </div>
      </Form>
    );
  }
};

export default SellShot_2;
